// @flow

import React from 'react'
import styled from 'styled-components'
import Path from 'routes/path'

const SelectBox = styled.select`
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
`

type PropTypes = {
  eventType: string,
  onChangeOtherEventType: Function,
}

class CategorySearchHeader extends React.Component<PropTypes> {
  render() {
    const mainGroup = ['party', 'class', 'photo_shoot']
    const otherGroup = [
      'film_shoot',
      'studio',
      'performance',
      'sports',
      'office',
      'wedding',
      'event',
      'other',
    ]
    const isOtherCurrent = otherGroup.indexOf(this.props.eventType) >= 0
    const otherText = isOtherCurrent
      ? i18n.t(`eventType.${this.props.eventType}`)
      : i18n.t('eventType.other')
    const buttonClassName = 'site-header__search-menu-button'
    let otherClassName = buttonClassName
    if (isOtherCurrent) otherClassName += ' is-current'

    return (
      <div>
        <div className="site-header__search sm-hide">
          <div className="site-header__search-menu sm-hide">
            <ul>
              {mainGroup.map(category => {
                let className = buttonClassName
                if (this.props.eventType === category)
                  className += ' is-current'
                return (
                  <li key={category} className="site-header__search-menu-item">
                    <a
                      className={className}
                      href={Path.searchCategory(category, true)}
                    >
                      {i18n.t(`eventType.${category}`)}
                    </a>
                  </li>
                )
              })}
              <li className="site-header__search-menu-item">
                <a className={buttonClassName} href={Path.staySearch()}>
                  {i18n.t('eventType.stay')}
                </a>
              </li>
              <li className="site-header__search-menu-item site-header__search-menu-item-others">
                <a className={otherClassName} href={'#'}>
                  {otherText}
                </a>
                <SelectBox
                  name="others"
                  onChange={this.props.onChangeOtherEventType}
                >
                  <option value="" />
                  {otherGroup.map(category => (
                    <option key={category} value={category}>
                      {i18n.t(`eventType.${category}`)}
                    </option>
                  ))}
                </SelectBox>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}

export default CategorySearchHeader



// WEBPACK FOOTER //
// ./src/components/organisms/CategorySearchHeader.js